import React from 'react'
import { HashLoader } from 'react-spinners'
import Button from '../button/Button'
import styles from './LoadingWithClose.module.css'

function LoadingWithClose({ loading, onClose, text }) {
    return (
        <>
            {loading ?
                <div className={styles.overlay}>
                    <div className={styles.loadingContainer}>
                        <div className={styles.text}>{text}</div>
                        <HashLoader className={styles.loader} loading={true} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768"></HashLoader>
                        <Button onClick={onClose}>ปิด</Button>
                    </div>
                </div>
                :
                null
            }
        </>


    )
}

export default LoadingWithClose